export default [{
    dictKey: '',
    dictValue: '全部'
}, {
    dictKey: '0',
    dictValue: '系统终止'
}, {
    dictKey: '1',
    dictValue: '手动终止'
},{
    dictKey: '2',
    dictValue: '异常终止'
}];



// WEBPACK FOOTER //
// ./src/service/constant/StopStatus.js